
import { AloConfigBase, cleanAloConfigBase, getDefaultAloConfigBase } from './AloConfigBase'


export interface AloConfigActivity extends AloConfigBase { 
    youtube:string,
    infosPlus:Array<string>
    objectifsPlus:Array<string>  
}

export const getDefaultAloConfigActivity = ():AloConfigActivity => {
    return {  
        ...getDefaultAloConfigBase(),
        youtube:'',
        infosPlus:[],
        objectifsPlus:[]
    }
}

export const cleanAloConfigActivity = (config:AloConfigActivity) => {
    cleanAloConfigBase(config)    
    if(!config) return    
}